import React from 'react';

import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Routes,
  Route
} from "react-router-dom";

import Default from './layouts/Default';
import Merchant from './layouts/Merchant';
import Error from './layouts/Error';

import Home from './pages/Home';
import Register from './pages/Register';
import MerchantDashboard from './pages/merchant/Dashboard';
import MerchantInvoice from './pages/merchant/Invoice';
import MerchantInvoiceCreate from './pages/merchant/InvoiceCreate';
import MerchantInvoiceQr from './pages/merchant/InvoiceQr';
import MerchantAccount from './pages/merchant/Account';
import MerchantSettings from './pages/merchant/Settings';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

export default function App() {

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
          <Route
            path="/"
            element={<Default />} 
            errorElement={<Error />}
            >
            <Route index element={<Home />} />
            <Route path="register" element={<Register />}  />
            <Route path="register/step_1" element={<Register />}  />
            <Route path="register/step_2" element={<Register />}  />
            <Route path="register/step_3" element={<Register />}  />
            <Route path="register/step_4" element={<Register />}  />
            <Route path="register/confirm" element={<Register />}  />
          </Route>

          <Route path="merchant" element={<Merchant />} errorElement={<Error />} >
            <Route index element={<MerchantDashboard />} />
            <Route path="dashboard" element={<MerchantDashboard />} />
            <Route path="invoices/:invoiceId" element={<MerchantInvoice />}  />
            <Route path="invoices/:invoiceId/qr_code" element={<MerchantInvoiceQr />}  />
            <Route path="invoices/new" element={<MerchantInvoiceCreate />}  />
            <Route path="settings/emails" element={<MerchantSettings />} />
            <Route path="settings/form" element={<MerchantSettings />} />
            <Route path="settings/reviews" element={<MerchantSettings />} />
            <Route path="settings/customize" element={<MerchantSettings />} />
            <Route path="account" element={<MerchantAccount />} />
            <Route path="account/user_profile" element={<MerchantAccount />} />
            <Route path="account/integrations" element={<MerchantAccount />} />
          </Route>

      </>
    )
  );



  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  )
}